import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const outreachFormRequest = createAction(types.OUTREACH_FORM_REQUEST);
export const outreachFormSuccess = createAction(types.OUTREACH_FORM_SUCCESS);
export const outreachFormFailure = createAction(types.OUTREACH_FORM_FAILURE);

export const updateOutreachFormRequest = createAction(
  types.UPDATE_OUTREACH_FORM_REQUEST,
);
export const updateOutreachFormSuccess = createAction(
  types.UPDATE_OUTREACH_FORM_SUCCESS,
);
export const updateOutreachFormFailure = createAction(
  types.UPDATE_OUTREACH_FORM_FAILURE,
);

export const outreachFormsStatusRequest = createAction(
  types.OUTREACH_FORMS_STATUS_REQUEST,
);
export const outreachFormsStatusSuccess = createAction(
  types.OUTREACH_FORMS_STATUS_SUCCESS,
);
export const outreachFormsStatusFailure = createAction(
  types.OUTREACH_FORMS_STATUS_FAILURE,
);

export default {
  outreachFormRequest,
  outreachFormSuccess,
  outreachFormFailure,
  updateOutreachFormRequest,
  updateOutreachFormSuccess,
  updateOutreachFormFailure,
  outreachFormsStatusRequest,
  outreachFormsStatusSuccess,
  outreachFormsStatusFailure,
};
